import { render } from "./BulkJobDetail.vue?vue&type=template&id=066f7e9a&scoped=true"
import script from "./BulkJobDetail.vue?vue&type=script&lang=js"
export * from "./BulkJobDetail.vue?vue&type=script&lang=js"

import "./BulkJobDetail.vue?vue&type=style&index=0&id=066f7e9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066f7e9a"]])

export default __exports__